import * as yup from "yup";

export const aclSchema = yup.object().shape({
  newName: yup.string().required("لطفا نام جدید را وارد کنید."),

}).required();
